import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.347}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 59492 88140"
    {...props}
  >
    <path
      d="M59466 44581 52477 1633C52324 692 51510 0 50556 0H8936c-954 0-1768 692-1921 1633L26 44581c-192 1183 722 2259 1921 2259h20446c-246 0-485 62-692 194-1604 1015-7667 7018-7827 39774-4 732 593 1332 1325 1332h29095c734 0 1329-601 1325-1334-161-32755-6224-38757-7826-39772-208-132-447-194-692-194h20444c1199-1 2113-1076 1921-2259zM33747 77875h-8001c-736 0-1329-601-1325-1337 88-14177 1571-18521 2416-19846 236-369 658-578 1094-578h3630c438 0 858 210 1094 578 845 1325 2328 5669 2416 19846 5 736-587 1337-1324 1337z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
